import React, { useState, useCallback, useEffect } from 'react';

import ScrollContainer from '../../components/ScrollContainerV2';
import { InputNumber, Modal, Select, Upload } from 'antd';

import { withTranslation } from 'react-i18next';
import { HYBRID_MAIL_ROOM } from '../Dashboard/StatusMonitoring/HybridMail/TranslationValue';
import Loader from '../../components/Loader';

import FontsProvider from '../../context/fontsContext';
import HybridMail from '../Dashboard/StatusMonitoring/HybridMail';
import BatchList from './BatchList';
import AdvanceFilter from '../MailRoom/AdvanceFilter';
import { getWeek } from '../../utils/javascript';
import { getAllHybridMailBatches } from '../../utils/services/hybridMailAPI';
import { BulkUploadButton, DataLoader, Header, HybridContainer, Main, SendLetterTitle, UploadContentWrapper } from './styles';
import BatchDetails from './BatchDetails';
import { BATCH_LIST } from '../MailRoom/translationValues';

const acceptedExtension = ['.docx', '.pdf', '.txt'];
const NAMESPACES = ['HYBRID_MAIL_ROOM', 'INSERT_NAMESPACES', 'HYBRID_MAIL'];

const pageLimit = 15;

const HybridMailRoom = props => {
  const { t } = props;
  const [showDrawer, setShowDrawer] = useState(false);
  const [fileUpload, showFileUpload] = useState(false);
  const [recipient, setRecipient] = useState('multiple');
  const [splitOnCriteria, setSplitOnCriteria] = useState('address');
  const [pageCount, setPageCount] = useState(null);
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [showHybridMail, setShowHybridMail] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [searchValue, setSearchValue] = useState(null);
  const [startAndEndDate, setStartAndEndDate] = useState(null);
  const [dateFilterApplied, setDateFilterApplied] = useState(false);
  const [batchList, setBatchList] = useState([]);
  const [batchCount, setBatchCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [fetchingMoreData, setFetchingMoreData] = useState(false);
  const [createBatch, setCreateBatch] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [batchData, setBatchData] = useState(null);
  const [printFailures, setPrintFailures] = useState(false);

  const customRequest = useCallback(
    async ({ file: requestFile }) => {
      setIsLoading(true);
      let file = new File([requestFile], requestFile.name, { type: requestFile.type });
      setSelectedPDF(file);
      showFileUpload(false);
      setShowHybridMail(true);
      setIsLoading(false);
      file.uid = requestFile.uid;
      let fileExtension = requestFile.name
        .split('.')
        [file.name.split('.').length - 1].toLowerCase();
      let isValidFileExtension = acceptedExtension.some(data => {
        return data === fileExtension;
      });
      console.log({ requestFile });

      const documentName = requestFile.name.split('.')[0].replaceAll(' ', '_');

      //   history.push(`/hybridDesign/${documentName}`)
    },
    [recipient, splitOnCriteria, pageCount],
  );

  useEffect(() => {
    setDefaultWeek();
  }, []);

  const onRefresh = () => {
      setShowHybridMail(false);
      setBatchList([])
      setBatchCount(0);
      setCurrentPage(1);
      fetchBatchDetails(1);
  }
  

  useEffect(() => {
    if (startAndEndDate?.startDate && startAndEndDate?.endDate) {
      setCurrentPage(1);
      fetchBatchDetails(1);
    }
  }, [searchValue, startAndEndDate]);

  useEffect(() => {
    if (currentPage > 1) {
      setFetchingMoreData(true);
      fetchBatchDetails(currentPage);
    }
  }, [currentPage]);

  const setDefaultWeek = () => {
    let startAndEndDate = getWeek();
    let dates = {
      startDate: startAndEndDate.startDate,
      endDate: startAndEndDate.endDate,
    };
    setStartAndEndDate(dates);
  };

  const fetchBatchDetails = useCallback(
    async page => {
      if (page === 1) {
        setIsLoading(true);
      }
      let dateRange = startAndEndDate;
      if (!dateFilterApplied) {
        let startAndEndDate = getWeek();
        dateRange = {
          startDate: startAndEndDate.startDate,
          endDate: startAndEndDate.endDate,
        };
      }
      let payload = {
        sortDirection: 'DESC',
        sortBy: 'createdOn',
        size: pageLimit,
      };
      // if (dateRange?.startDate && dateRange?.endDate) {
      //   payload.fromDate = dateRange.startDate;
      //   payload.toDate = dateRange.endDate;
      // }
      payload.page = page -1;
      if (searchValue !== null && searchValue !== '') {
        payload.name = searchValue;
      }
      const response = await getAllHybridMailBatches(payload);
      if (response?.batches && response?.pagination) {
        // setLastUpdatedOn(dateTimeConversion(new Date(), false, true, false));
        if (page && page > 1) {
          setBatchList(batchList => batchList?.concat(response?.batches));
        } else {
          setBatchList(response?.batches);
        }
        setBatchCount(response?.pagination?.totalRecords);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
      setFetchingMoreData(false);
    },
    [searchValue, startAndEndDate, currentPage],
  );

  const onCancel = () => {
    setBatchData(null);
    setPrintFailures(false);
  };

  const fetchMoreData = useCallback(() => {
    if (batchCount > currentPage * pageLimit) {
      setCurrentPage(currentPage => currentPage + 1);
    }
  }, [currentPage, batchCount]);

  useEffect(() => {
    if (createBatch) {
      setShowDrawer(false);
    }
  }, [createBatch]);

  // const onRefresh = () => {
  //   setBatchList([])
  //   setBatchCount(0);
  //   setCurrentPage(1);
  //   fetchBatchDetails(1);
  // }

  return (
    <Main justifyContent={batchList.length > 2 ? 'center' : 'flex-start'}>
      {!showHybridMail && (
        <>
          <HybridContainer className={showDrawer ? 'collapse' : 'expand'}>
            <Header
              justifyContent="center"
              className={showDrawer ? 'collapse' : 'expand'}
              height={'10vh'}
            >
              <h2 className="title">
                {t(
                  HYBRID_MAIL_ROOM.HYBRID_MAIL_ROOM_TITLE.key,
                  HYBRID_MAIL_ROOM.HYBRID_MAIL_ROOM_TITLE.value,
                )}
              </h2>
            </Header>
            <ScrollContainer
              customClassName={`batchList ${showDrawer ? 'collapse' : 'expand'}`}
              fetchMoreData={fetchMoreData}
            >
              <BatchList
                showFileUpload={showFileUpload}
                batchList={batchList}
                setBatchData={setBatchData}
              />
              <DataLoader>
                  {fetchingMoreData
                    ? t(BATCH_LIST.LOADING.key, BATCH_LIST.LOADING.value)
                    : batchList?.length === batchCount ? (batchCount === 0 ? t(BATCH_LIST.NO_BATCH_MESSAGE.key, BATCH_LIST.NO_BATCH_MESSAGE.value) : t(BATCH_LIST.GOT_ALL_RESULT_MESSAGE.key, BATCH_LIST.GOT_ALL_RESULT_MESSAGE.value)) : ''}
                </DataLoader>
              <Modal
                width={'60%'}
                centered
                closable={true}
                placement="right"
                onCancel={() => showFileUpload(false)}
                visible={fileUpload}
                footer={[]}
                className="mailRoomDoc_modal"
              >
                <SendLetterTitle>
                  {t(
                    HYBRID_MAIL_ROOM.SEND_LETTERS_TEXT.key,
                    HYBRID_MAIL_ROOM.SEND_LETTERS_TEXT.value,
                  )}
                </SendLetterTitle>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    width: '100%',
                    marginTop: '10px',
                  }}
                >
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <p style={{ fontWeight: 600 }}>
                      {t(
                        HYBRID_MAIL_ROOM.SPLIT_CRITERIA_LABEL.key,
                        HYBRID_MAIL_ROOM.SPLIT_CRITERIA_LABEL.value,
                      )}
                    </p>
                    <Select
                      value={splitOnCriteria}
                      style={{ width: '120px' }}
                      onChange={value => {
                        value === 'address' && setPageCount(null);
                        setSplitOnCriteria(value);
                      }}
                    >
                      <Select.Option value="address">
                        {t(
                          HYBRID_MAIL_ROOM.SPLIT_CRITERIA_ADDRESS.key,
                          HYBRID_MAIL_ROOM.SPLIT_CRITERIA_ADDRESS.value,
                        )}
                      </Select.Option>
                      <Select.Option value="pageCount">
                        {t(
                          HYBRID_MAIL_ROOM.SPLIT_CRITERIA_PAGE.key,
                          HYBRID_MAIL_ROOM.SPLIT_CRITERIA_PAGE.value,
                        )}
                      </Select.Option>
                    </Select>
                  </div>
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <p style={{ fontWeight: 600 }}>
                      {t(
                        HYBRID_MAIL_ROOM.PAGE_COUNT_LABEL.key,
                        HYBRID_MAIL_ROOM.PAGE_COUNT_LABEL.value,
                      )}
                    </p>
                    <InputNumber
                      value={pageCount}
                      disabled={splitOnCriteria === 'address' || splitOnCriteria === null}
                      onChange={value => setPageCount(value)}
                    />
                  </div>
                </div>

                <Upload
                  accept=".pdf, .docx, .txt"
                  showUploadList={false}
                  className="varUpload full"
                  customRequest={customRequest}
                >
                  <BulkUploadButton>
                    <UploadContentWrapper>
                      <p className="import">
                        {t(HYBRID_MAIL_ROOM.DRAG_AND_DROP.key, HYBRID_MAIL_ROOM.DRAG_AND_DROP.value)}
                      </p>
                      <p className="desc">
                        {t(
                          HYBRID_MAIL_ROOM.TO_SEND_LETTERS.key,
                          HYBRID_MAIL_ROOM.TO_SEND_LETTERS.value,
                        )}
                      </p>
                      {isLoading && <Loader />}
                    </UploadContentWrapper>
                  </BulkUploadButton>
                </Upload>
              </Modal>
            </ScrollContainer>
          </HybridContainer>
          <AdvanceFilter
            visibility={true}
            title={'Batch Filter'}
            setSearchValue={setSearchValue}
            startAndEndDate={startAndEndDate}
            setStartAndEndDate={setStartAndEndDate}
            setDefaultWeek={setDefaultWeek}
            showDrawer={showDrawer}
            setShowDrawer={setShowDrawer}
            createBatch={createBatch} 
            deleteDocuments={undefined}
            setDateFilterApplied={setDateFilterApplied}
          />
          {batchData && (
            <BatchDetails
              batchData={batchData}
              startAndEndDate={startAndEndDate}
              onCancel={onCancel}
            />
          )}
        </>
      )}
      {showHybridMail && (
        <FontsProvider>
          <HybridMail
            visible={true}
            hybridInfo={{splitOnCriteria: splitOnCriteria, pageCount, uploadedFile: selectedPDF  }}
            onRefresh={onRefresh}
            t={t}
          />
        </FontsProvider>
      )}
    </Main>
  );
};

export default withTranslation(NAMESPACES)(HybridMailRoom);
